/* eslint-disable import/no-anonymous-default-export */
import SystemDataConstants from './systemDataConsts';

const initialState = {
  status: '',
  links: [],
  banners: [],
  businessInfo: {},
  mediaRegistry: [],
  categories: [],
  services: [],
  infoCards: [],
  language: 'en',
  dir: 'ltr',
  // language: 'he',
  // dir: 'rtl',
  // Which content languages the site serves (from backend config). Drives the
  // language toggle visibility and the admin editor's language picker.
  supportedLanguages: ['en'],
};

export default (state = initialState, action) => {
  switch (action.type) {
    case SystemDataConstants.UPDATE_SYSTEM_DATA: {
      return {
        ...state,
        ...action.payload, // This merges { language: 'en', dir: 'ltr' } into the state
      };
    }
    // Bootstrap — the whole landing payload applied in one shot (one re-render).
    case SystemDataConstants.SYSTEM_SET_BOOTSTRAP: {
      const p = action.payload || {};
      return {
        ...state,
        status: 'success',
        ...(p.language ? { language: p.language } : {}),
        ...(p.dir ? { dir: p.dir } : {}),
        ...(Array.isArray(p.supportedLanguages) && p.supportedLanguages.length
          ? { supportedLanguages: p.supportedLanguages } : {}),
        businessInfo: p.businessInfo && typeof p.businessInfo === 'object' ? p.businessInfo : state.businessInfo,
        banners: Array.isArray(p.banners) ? p.banners : state.banners,
        links: Array.isArray(p.links) ? p.links : state.links,
        categories: Array.isArray(p.categories) ? p.categories : state.categories,
        services: Array.isArray(p.services) ? p.services : state.services,
        infoCards: Array.isArray(p.infoCards) ? p.infoCards : state.infoCards,
      };
    }
    // Links
    case SystemDataConstants.SYSTEM_SET_LINKS: {
      return {
        ...state,
        status: 'success',
        links: Array.isArray(action.payload) ? action.payload : [],
      };
    }
    case SystemDataConstants.SYSTEM_CLEAR_LINKS: {
      return {
        ...state,
        status: 'success',
        links: [],
      };
    }

    // Banners
    case SystemDataConstants.SYSTEM_SET_BANNERS: {
      return {
        ...state,
        status: 'success',
        banners: Array.isArray(action.payload) ? action.payload : [],
      };
    }
    case SystemDataConstants.SYSTEM_CLEAR_BANNERS: {
      return {
        ...state,
        status: 'success',
        banners: [],
      };
    }

    // Business Info
    case SystemDataConstants.SYSTEM_SET_BUSINESS_INFO: {
      return {
        ...state,
        status: 'success',
        businessInfo: action.payload && typeof action.payload === 'object' ? action.payload : {},
      };
    }
    case SystemDataConstants.SYSTEM_CLEAR_BUSINESS_INFO: {
      return {
        ...state,
        status: 'success',
        businessInfo: {},
      };
    }

    // --- NEW: Media Registry / Gallery ---
    case SystemDataConstants.SYSTEM_SET_MEDIA_REGISTRY: {
      return {
        ...state,
        status: 'success',
        mediaRegistry: Array.isArray(action.payload) ? action.payload : [],
      };
    }

    case SystemDataConstants.SYSTEM_CLEAR_MEDIA_REGISTRY: {
      return {
        ...state,
        status: 'success',
        mediaRegistry: [],
      };
    }

    case SystemDataConstants.SYSTEM_SET_SERVICES: {
      return {
        ...state,
        status: 'success',
        services: Array.isArray(action.payload) ? action.payload : [],
      };
    }

    case SystemDataConstants.SYSTEM_CLEAR_SERVICES: {
      return {
        ...state,
        status: 'success',
        services: [],
      };
    }

    // Categories
    case SystemDataConstants.SYSTEM_SET_CATEGORIES: {
      return {
        ...state,
        status: 'success',
        categories: Array.isArray(action.payload) ? action.payload : [],
      };
    }

    case SystemDataConstants.SYSTEM_CLEAR_CATEGORIES: {
      return {
        ...state,
        status: 'success',
        categories: [],
      };
    }

    default:
      return state;
  }
};